module.exports = __webpack_public_path__ + "static/assets/129b2211db006c5e33efafee54dcd89d.png";